/* fx-ios.js - the real device pass.

   Three jobs, all of them things CSS cannot do on iOS.

   1. Publish the VISUAL viewport as --fx-vvh, so the modal can be sized to
      the space actually left on screen. 100dvh, 100% and
      -webkit-fill-available all describe a viewport that ignores the software
      keyboard, which is why the VIN panel came up as an empty white box with
      the close button scrolled out of reach.

   2. Guarantee a way out. The extension hides .vin-modal-close the moment its
      toolbar gains is-floating, on the assumption that .vin-modal-top has
      taken over. When that assumption fails the modal is a trap.

   3. Drop the diagram popup's redundant footer link.

   THERE WAS A FOURTH JOB AND IT WAS THE CAUSE OF A VISIBLE BUG.

   This file used to shorten the selector bar's label, dropping a segment at a
   time until it fitted its button. fx-ios-e.js was written later to do the
   same thing after this copy was wrongly diagnosed as never firing. It fires.
   Both fired, and so did the extension, which owns that label and rewrites it
   from its own data attribute on its own schedule.

   A MutationObserver on the label recorded the result, on a 700ms cycle, for
   as long as the page stayed open:

     98602  Sport Range                       <- this file shortened it
     98676  Sport Range - Super Sport - 2025  <- the extension put it back
     99302  Sport Range
     99378  Sport Range - Super Sport - 2025

   On a phone that reads as an ellipsis flickering on and off three times a
   second at the end of the selector bar. Retiring fx-ios-e.js removed one of
   the two writers and left this one, which is why the flicker survived.

   So the shortening is gone from here too. The label keeps the ellipsis the
   extension already styles for, fx-ios-g.css buys it a little more room, and
   tapping it opens the sheet that shows the whole selection.

   THE RULE: where the app extension writes the text, style the box, not the
   text. Script that competes with the extension for a node loses visibly even
   when it is working.

   No requestAnimationFrame: document.hidden is true in an automation tab and
   rAF never fires there. Timers only, like every other fx script. */
(function () {
  'use strict';

  if (window.fxIosOn) return;
  window.fxIosOn = 1;

  var root = document.documentElement;
  var vv = window.visualViewport || null;

  /* ---- 1. the visual viewport ---------------------------------------- */
  function publish() {
    var h = vv ? vv.height : window.innerHeight;
    var t = vv ? vv.offsetTop : 0;
    if (!h) return;
    root.style.setProperty('--fx-vvh', Math.round(h) + 'px');
    root.style.setProperty('--fx-vvt', Math.round(t) + 'px');

    /* A keyboard takes a large bite. A URL bar collapsing takes a small one,
       and must not be mistaken for one. */
    var eaten = window.innerHeight - h;
    root.setAttribute('data-fx-kbd', eaten > 140 ? '1' : '0');
  }

  if (vv) {
    vv.addEventListener('resize', publish);
    vv.addEventListener('scroll', publish);
  }
  window.addEventListener('orientationchange', function () { setTimeout(publish, 240); });
  window.addEventListener('resize', publish);
  publish();
  setInterval(publish, 900);

  /* ---- 2. a guaranteed way out --------------------------------------- */
  var SHUT = '.vin-modal-close, .vin-modal-top';

  function onScreen(el) {
    if (!el || el.offsetParent === null) return false;
    var r = el.getBoundingClientRect();
    if (r.width < 8 || r.height < 8) return false;
    var h = vv ? vv.height : window.innerHeight;
    return r.top < h - 4 && r.bottom > 4 && r.left < window.innerWidth - 4 && r.right > 4;
  }

  function shut() {
    var all = document.querySelectorAll(SHUT);
    for (var i = 0; i < all.length; i++) {
      try { all[i].click(); } catch (e) {}
    }
    document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true }));
    var host = document.querySelector('vin-search-modal');
    if (host && typeof host.close === 'function') {
      try { host.close(); } catch (e) {}
    }
  }

  function escHatch() {
    var open = document.body.classList.contains('vin-modal-open');
    var have = document.querySelector('.fx-esc');

    if (!open || window.innerWidth > 899) {
      if (have) have.remove();
      return;
    }

    var ok = false;
    var all = document.querySelectorAll(SHUT);
    for (var i = 0; i < all.length; i++) {
      if (onScreen(all[i])) { ok = true; break; }
    }
    if (ok) { if (have) have.remove(); return; }
    if (have) return;

    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'fx-esc';
    b.setAttribute('aria-label', 'Close');
    b.textContent = '×';
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      shut();
    });
    document.body.appendChild(b);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains('vin-modal-open')) shut();
  });

  /* ---- 3. the diagram popup's footer link ----------------------------
     "View diagram product page" sat under the part rows, overset, and led
     somewhere the reader is already looking at. */
  function dropDiagramLink() {
    var box = document.querySelector('.vin-diagram-expand');
    if (!box) return;
    var all = box.querySelectorAll('a, button');
    for (var i = 0; i < all.length; i++) {
      var t = (all[i].textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (t === 'view diagram product page') all[i].remove();
    }
  }

  function tick() {
    escHatch();
    try { dropDiagramLink(); } catch (e) {}
  }

  setInterval(tick, 700);
  setTimeout(tick, 300);
})();
